<template>
    <tr v-if="customer">
        <td>{{ customer.username }}</td>
        <td>{{ customer.password }}</td>
        <td>{{ customer.company_name }}</td>
        <td>{{ customer.email }}</td>
        <td>{{ customer.phone }}</td>
        <td>
            <pre class="token z-depth-1">{{ customer.authentication_token }}</pre>
        </td>
        <td>
            <div class="ui items">
                <router-link class="item" v-for="(contract, index) in customer.contracts"
                    :key="contract.identity"
                    :to="{
                        name: 'provider_contract',
                        params: {
                            customer_identity: customer.identity,
                            contract_identity: contract.identity
                        }
                    }">
                    {{ index + 1 }}. {{ contract.name }}
                    &nbsp;
                </router-link>
            </div>
        </td>
        <td>{{ customer.fax }}</td>
        <td>
            <span v-if="!customer.is_banned">
                <i class="check icon"></i> {{ $t('ui.pages.customers.normal') }}
            </span>
            <span v-if="customer.is_banned">
                <i class="remove icon"></i> {{ $t('ui.pages.customers.banned') }}
            </span>
        </td>
        <td>
            <router-link :to="{name: 'provider_customer', params: {customer_identity: customer.identity}}" class="ui basic primary button">
                {{ $t('ui.general.show') }}
            </router-link>
            <a class="ui basic orange button" @click="$parent.proxy_login(customer)" v-if="build_env != 'electron'">
                {{ $t('ui.pages.customers.proxy_login') }}
            </a>
            <a class="ui basic red button" @click="$parent.associate_to_node(customer)" v-if="customer.customer_node">
                同步
            </a>
            <!-- <a href="#" @click.prevent="delete_customer" class="ui basic red button">{{ $t('ui.general.delete') }}</a> -->
            <button class="ui basic button" @click="$parent.toggle_is_banned(customer)"
                :class="[
                    customer.is_banned ? 'positive' : 'negative',
                    customer.is_loading ? 'loading' : ''
                ]">
                <span v-if="customer.is_banned">{{ $t('ui.pages.customers.unbanned') }}</span>
                <span v-else>{{ $t('ui.pages.customers.banned') }}</span>
            </button>
        </td>
    </tr>
</template>

<script>
export default {
    name: "ProviderCustomersIndexItem",
    props: {
        customer: Object
    },
    data() {
        return {
            is_loading: false
        }
    },
    watch: {
    },
    computed: {
        build_env() {
            return ENV.VUE_APP_BUILD_ENV
        }
    },
    mounted() {
    },
    methods: {
        delete_customer() {
            if (confirm(this.$t('ui.notifications.warning.are_you_sure_to_delete_it'))) {
                this.is_loading = true
                var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_customer_delete).parse({
                    "customer_identity": this.customer.identity,
                })

                axios.get(url, {headers: { Authorization: localStorage.getItem("authentication_token") }})
                    .then(response => {
                        if (response.data.status == "success") {
                            this.$parent.fetch_customers()
                            // this.$noty.success('刪除客戶成功')
                            this.$noty.success(
                                this.$t('ui.notifications.success.delete__name', {
                                    name: this.$t('models.customers')
                                })
                            )
                        } else {
                            // this.$noty.error('刪除客戶失敗')
                            this.$noty.error(
                                this.$t('ui.notifications.error.delete__name', {
                                    name: this.$t('models.contracts')
                                })
                            )
                        }
                    })
                    .catch(error => {
                        console.log(error.response)
                        // this.$noty.error('刪除客戶失敗')
                        this.$noty.error(
                            this.$t('ui.notifications.error.delete__name', {
                                name: this.$t('models.customers'),
                                reason: ': ' + error.response
                            })
                        )
                    }).finally(() => {
                        this.is_loading = false
                    })
            }
        },
        delete_contract(contract_identity) {
            if (confirm(this.$t('ui.notifications.warning.are_you_sure_to_delete_it'))) {
                this.is_loading = true
                var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_contract_delete).parse({
                    "contract_identity": contract_identity,
                })

                axios.get(url, {headers: { Authorization: localStorage.getItem("authentication_token") }})
                    .then(response => {
                        if (response.data.status == "success") {
                            this.$parent.fetch_customers()
                            // this.$noty.success('刪除客戶成功')
                            this.$bus.$emit("out_of_date", this.$store.state.instance_identity, "customers")
                            this.$noty.success(
                                this.$t('ui.notifications.success.delete__name', {
                                    name: this.$t('models.contracts')
                                })
                            )
                        } else {
                            // this.$noty.error('刪除客戶失敗')
                            this.$noty.error(
                                this.$t('ui.notifications.error.delete__name', {
                                    name: this.$t('models.contracts'),
                                })
                            )
                        }
                    })
                    .catch(error => {
                        console.log(error.response)
                        // this.$noty.error('刪除客戶失敗')
                        this.$noty.error(
                            this.$t('ui.notifications.error.delete__name', {
                                name: this.$t('models.customers'),
                                reason: ': ' + error.response
                            })
                        )
                    }).finally(() => {
                        this.is_loading = false
                    })
            }
        },
    },
}
</script>

<style scoped lang="scss">
pre.token {
    background: #ffffed;
    padding: 10px;
    width: 200px;
    overflow: auto;
    border: 1px solid #EEE;
    border-radius: 3px;
}
</style>
